const FormatarCPFCNPJTempoReal = (value) => {
  if (!value) {
    return null;
  }
  value = value.toUpperCase();
  let inputValue = value.replace(/[^a-zA-Z0-9]/g, '');

  if (inputValue.length <= 11) {
    // CPF Formatting
    inputValue = inputValue.replace(/(\d{3})(\d)/, '$1.$2');
    inputValue = inputValue.replace(/(\d{3})(\d)/, '$1.$2');
    inputValue = inputValue.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    // CNPJ Formatting
    const rawLength = inputValue.length;
    inputValue = inputValue.replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9])/, '$1.$2');
    inputValue = inputValue.replace(/^([a-zA-Z0-9]{2})\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, '$1.$2.$3');
    inputValue = inputValue.replace(/\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, '.$1/$2');
    if (rawLength > 12) {
      inputValue = inputValue.replace(/([a-zA-Z0-9]{4})(\d{0,2}).*$/, '$1-$2');
    }
  }

  return inputValue;
};

export default FormatarCPFCNPJTempoReal;
